import { z } from "zod";
import { optionalCounterpartyTextSchema } from "./counterparty.schema";

/**
 * A single place attached to a counterparty. Every content field is nullable;
 * the row must carry at least one non-null address field (enforced in the
 * service against the merged result, since PATCH is partial).
 */
export const counterpartyAddressSchema = z.object({
    id: z.string(),
    counterpartyId: z.string(),
    label: z.string().nullable(),
    isPrimary: z.boolean(),
    street: z.string().nullable(),
    street2: z.string().nullable(),
    city: z.string().nullable(),
    postalCode: z.string().nullable(),
    state: z.string().nullable(),
    country: z.string().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});

export type CounterpartyAddress = z.infer<typeof counterpartyAddressSchema>;

export const counterpartyAddressContentFields = {
    label: optionalCounterpartyTextSchema,
    street: optionalCounterpartyTextSchema,
    street2: optionalCounterpartyTextSchema,
    city: optionalCounterpartyTextSchema,
    postalCode: optionalCounterpartyTextSchema,
    state: optionalCounterpartyTextSchema,
    country: optionalCounterpartyTextSchema,
};

export const createCounterpartyAddressBodySchema = z.object({
    ...counterpartyAddressContentFields,
    isPrimary: z.boolean().optional(),
});

export type CreateCounterpartyAddressBody = z.infer<
    typeof createCounterpartyAddressBodySchema
>;

export const updateCounterpartyAddressBodySchema = z
    .object(counterpartyAddressContentFields)
    .refine((body) => Object.keys(body).length > 0, {
        message: "At least one field must be provided",
    });

export type UpdateCounterpartyAddressBody = z.infer<
    typeof updateCounterpartyAddressBodySchema
>;
